module.exports = __webpack_public_path__ + "src/assets/img/topaused.4993c725.png";